<template>
    <form id="onboarding-de" class="wrapper wrapper-tab wrapper-tab-3" role="form" method="post" @submit.prevent="" novalidate>
        <header>
            <span class="new-headline-xlg text-centered">Ihre Körpermaße</span>
        </header>

        <div v-for="slider in sliders" :key="slider.id" class="input-wrapper wrapper-range">
            <div class="range-text">
                <strong>{{ slider.title }}</strong>
                <div class="range-output">
                    <input :class="'input-range-'+slider.id" type="number" placeholder="0" :value="slider.value > 0 ? slider.value : null">
                    <strong class="range-unit">{{ slider.unit }}</strong>
                </div>
            </div>
            <input :id="slider.id" :class="'input-range range-'+slider.id" type="range" :min="slider.min" :max="slider.max" step="1" :value="slider.value" data-rangeslider>
        
            <form-input-error v-if="slider.error" :error="slider.error"></form-input-error>
        </div>

        <v-button label="Weiter" size="lg" type="submit" full-width @onClick="onClickButton()"></v-button>
    </form>
</template>

<script>
    export default {
        props: {
            uuid: {
                type: String,
                required: true
            },
            data: {
                type: Object,
                required: false
            },
            type: {
                type: String,
                required: true
            }
        },
        
        data() {
            return {
                isDisabled: true,
                sliders: [
                    {
                        id: 'height',
                        min: 140,
                        max: 220,
                        unit: 'cm',
                        title: 'Wie groß sind Sie?',
                        value: (this.data && this.data.height) ?? 0,
                        error: null
                    },
                    {
                        id: 'weight',
                        min: 40,
                        max: 250,
                        unit: 'kg',
                        title: 'Ihr aktuelles Körpergewicht',
                        value: (this.data && this.data.weight) ?? 0,
                        error: null
                    },
                    {
                        id: 'waist',
                        min: 50,
                        max: 150,
                        unit: 'cm',
                        title: 'Ihr aktueller Bauchumfang',
                        value: (this.data && this.data.waist) ?? 0,
                        error: null
                    },
                ]
            }
        },

        mounted() {
            var that = this
            
            this.sliders.forEach(slider => {
                $('.range-'+slider.id).rangeslider({
                    polyfill: false,
                    onSlide: function(position, value) {
                        slider.value = value
                        slider.error = false
                    }
                })

                $('.input-range-'+slider.id).on('change', function() {
                    var value = $(this).val()

                    if(value >= slider.min && value <= slider.max) {
                        $('.range-'+slider.id).val(value).change()
                    } else {
                        slider.error = 'Der eingegebene Wert muss zwischen '+slider.min+' - '+slider.max+' '+slider.unit+' liegen.'
                    }
                })
            })

            setTimeout(() => {
                document.querySelector('.progress-back').addEventListener('click', function(e) {
                    that.saveData();
                }); 
            }, 50);
        },

        methods: {
            onClickButton () {
                this.validate()

                if(!this.isDisabled) {
                    this.submit()
                } else {
                    Vuemit.fire('Button--sending-failed', true)
                }
            },
            validate() {
                var that = this

                for(let slider of this.sliders) {
                    if(slider.value < slider.min || slider.value > slider.max) {
                        slider.error = 'Der eingegebene Wert muss zwischen '+slider.min+' - '+slider.max+' '+slider.unit+' liegen.'
                    }
                }

                for(let slider of this.sliders) {
                    if(slider.value >= slider.min && slider.value <= slider.max) {
                        that.isDisabled = false
                        slider.error = null
                    } else {
                        that.isDisabled = true
                        break
                    }
                }
            },
            submit() {
                let that = this

                var data = {
                    uuid: this.uuid,
                    answers: {
                        last_tab: {
                            key: 'last_tab',
                            value: this.type === 'first' ? '3' : '2'
                        }
                    }
                }

                this.sliders.forEach((slider, index) => {
                    data.answers[slider.id] = {key: slider.id, value: that.sliders[index].value.toString()}
                });

                axios
                    .post('/rwe-study', data, {
                        headers: {
                            'Accept-Language': 'de'
                        }
                    })
                    .then((e) => {
                        this.$emit('clicked', data.answers, true)
                    })
                    .catch((e) => {
                        console.log(e.response)
                        Vuemit.fire('Button--sending-failed', true)
                    })
            },
            saveData() {
                let that = this

                var data = {
                    answers: {}
                }

                this.sliders.forEach((slider, index) => {
                    data.answers[slider.id] = {key: slider.id, value: that.sliders[index].value.toString()}
                });

                this.$emit('clicked', data.answers, false)
            }
        }
    }
</script>